import React from 'react';
import { observer } from 'mobx-react';
import { makeStyles } from '@mui/styles';
import { storeKrunica } from '../store/KrunicaStore';
import ZdravoMarijaPocetak from './ZdravoMarijaPocetak';
import ZdravoMarijaKraj from './ZdravoMarijaKraj';
import Amen from './Amen';
import { getColor } from '../store/boje';

const useStyles = makeStyles((theme) => ({
  opisMolitve: {
    justifyContent: 'space-between',
    marginTop: '0.5rem',
    margin: ' auto',
    fontSize: '1.6rem',
    textAlign: 'center',
    padding: '0',
    height: '80vh',
    [theme.breakpoints.up('sm')]: {
      backgroundColor: '#e9e9e9',
      color: '#555',
      fontSize: '2rem',
      border: '1px solid #ece7e7',
      width: '50%',
      margin: 'auto',
    },
  },
  gospa: {
    color: getColor(2),
    animation: `$pomakDesno 1000ms ${theme.transitions.easing.easeInOut}`,
    '&:hover': {
      color: 'green',
    },
  },
  rita: {
    color: getColor(1),
    animation: `$pomakDesno 1000ms ${theme.transitions.easing.easeInOut}`,
    '&:hover': {
      color: 'green',
    },
  },
  gertruda: {
    color: getColor(0),
    animation: `$pomakDesno 1000ms ${theme.transitions.easing.easeInOut}`,
    '&:hover': {
      color: 'green',
    },
  },
  '@keyframes pomakDesno': {
    '0%': {
      opacity: 0,
      transform: 'translateX(-50%)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
}));

function Zrno() {
  const classes = useStyles();
  const { aktivnaZemlja, aktivnoOtajstvo, zrno, trenutnaKrunica } =
    storeKrunica;
  const { krunice } = aktivnaZemlja;

  // console.log('zrno=', zrno, 'trenutnaKrunica', trenutnaKrunica);
  //  {krunice.find((k) => k.value === trenutnaKrunica)?.label}

  return (
    <React.Fragment>
      <div className={classes.opisMolitve}>
        {(zrno === 2 ||
          zrno === 3 ||
          zrno === 4 ||
          trenutnaKrunica !== 'gertruda') && <ZdravoMarijaPocetak />}
        <div>
          <div
            className={
              trenutnaKrunica === 'gospa'
                ? classes.gospa
                : trenutnaKrunica === 'gertruda'
                  ? classes.gertruda
                  : classes.rita
            }
            title={zrno}
          >
            {zrno === 2 &&
              krunice.find((k) => k.value === trenutnaKrunica)?.vjera}
            {zrno === 3 &&
              krunice.find((k) => k.value === trenutnaKrunica)?.ufanje}
            {zrno === 4 &&
              krunice.find((k) => k.value === trenutnaKrunica)?.ljubav}
            {/* Prva desetica */}
            {trenutnaKrunica === 'rita' &&
              zrno > 6 &&
              zrno < 16 &&
              aktivnaZemlja.prvaDeseticaRita}
            {trenutnaKrunica === 'gertruda' &&
              zrno > 6 &&
              zrno < 16 &&
              krunice.find((k) => k.value === trenutnaKrunica)?.vjecniOce}
            {aktivnoOtajstvo === 'otajstvoZalosno' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 6 &&
              zrno < 16 &&
              aktivnaZemlja.prvaDeseticaZalosna}
            {aktivnoOtajstvo === 'otajstvoSlavno' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 6 &&
              zrno < 16 &&
              aktivnaZemlja.prvaDeseticaSlavna}
            {aktivnoOtajstvo === 'otajstvoRadosna' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 6 &&
              zrno < 16 &&
              aktivnaZemlja.prvaDeseticaRadosna}
            {aktivnoOtajstvo === 'otajstvoSvjetla' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 6 &&
              zrno < 16 &&
              aktivnaZemlja.prvaDeseticaSvjetla}
            {/* Druga desetica */}
            {trenutnaKrunica === 'rita' &&
              zrno > 17 &&
              zrno < 27 &&
              aktivnaZemlja.drugaDeseticaRita}
            {trenutnaKrunica === 'gertruda' &&
              zrno > 17 &&
              zrno < 27 &&
              krunice.find((k) => k.value === trenutnaKrunica)?.vjecniOce}
            {aktivnoOtajstvo === 'otajstvoZalosno' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 17 &&
              zrno < 27 &&
              aktivnaZemlja.drugaDeseticaZalosna}
            {aktivnoOtajstvo === 'otajstvoSlavno' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 17 &&
              zrno < 27 &&
              aktivnaZemlja.drugaDeseticaSlavna}
            {aktivnoOtajstvo === 'otajstvoRadosna' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 17 &&
              zrno < 27 &&
              aktivnaZemlja.drugaDeseticaRadosna}
            {aktivnoOtajstvo === 'otajstvoSvjetla' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 17 &&
              zrno < 27 &&
              aktivnaZemlja.drugaDeseticaSvjetla}
            {/* Treca desetica */}
            {trenutnaKrunica === 'rita' &&
              zrno > 28 &&
              zrno < 38 &&
              aktivnaZemlja.trecaDeseticaRita}
            {trenutnaKrunica === 'gertruda' &&
              zrno > 28 &&
              zrno < 38 &&
              krunice.find((k) => k.value === trenutnaKrunica)?.vjecniOce}
            {aktivnoOtajstvo === 'otajstvoZalosno' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 28 &&
              zrno < 38 &&
              aktivnaZemlja.trecaDeseticaZalosna}
            {aktivnoOtajstvo === 'otajstvoSlavno' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 28 &&
              zrno < 38 &&
              aktivnaZemlja.trecaDeseticaSlavna}
            {aktivnoOtajstvo === 'otajstvoRadosna' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 28 &&
              zrno < 38 &&
              aktivnaZemlja.trecaDeseticaRadosna}
            {aktivnoOtajstvo === 'otajstvoSvjetla' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 28 &&
              zrno < 38 &&
              aktivnaZemlja.trecaDeseticaSvjetla}
            {/* Četvrta desetica */}
            {trenutnaKrunica === 'rita' &&
              zrno > 39 &&
              zrno < 49 &&
              aktivnaZemlja.cetvrtaDeseticaRita}
            {trenutnaKrunica === 'gertruda' &&
              zrno > 39 &&
              zrno < 49 &&
              krunice.find((k) => k.value === trenutnaKrunica)?.vjecniOce}
            {aktivnoOtajstvo === 'otajstvoZalosno' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 39 &&
              zrno < 49 &&
              aktivnaZemlja.cetvrtaDeseticaZalosna}
            {aktivnoOtajstvo === 'otajstvoSlavno' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 39 &&
              zrno < 49 &&
              aktivnaZemlja.cetvrtaDeseticaSlavna}
            {aktivnoOtajstvo === 'otajstvoRadosna' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 39 &&
              zrno < 49 &&
              aktivnaZemlja.cetvrtaDeseticaRadosna}
            {aktivnoOtajstvo === 'otajstvoSvjetla' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 39 &&
              zrno < 49 &&
              aktivnaZemlja.cetvrtaDeseticaSvjetla}
            {/* Peta desetica */}
            {trenutnaKrunica === 'rita' &&
              zrno > 50 &&
              zrno < 60 &&
              aktivnaZemlja.petaDeseticaRita}
            {trenutnaKrunica === 'gertruda' &&
              zrno > 50 &&
              zrno < 60 &&
              krunice.find((k) => k.value === trenutnaKrunica)?.vjecniOce}
            {aktivnoOtajstvo === 'otajstvoZalosno' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 50 &&
              zrno < 60 &&
              aktivnaZemlja.petaDeseticaZalosna}
            {aktivnoOtajstvo === 'otajstvoSlavno' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 50 &&
              zrno < 60 &&
              aktivnaZemlja.petaDeseticaSlavna}
            {aktivnoOtajstvo === 'otajstvoRadosna' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 50 &&
              zrno < 60 &&
              aktivnaZemlja.petaDeseticaRadosna}
            {aktivnoOtajstvo === 'otajstvoSvjetla' &&
              trenutnaKrunica === 'gospa' &&
              zrno > 50 &&
              zrno < 60 &&
              aktivnaZemlja.petaDeseticaSvjetla}
          </div>
        </div>
        {(zrno === 2 ||
          zrno === 3 ||
          zrno === 4 ||
          trenutnaKrunica !== 'gertruda') && <ZdravoMarijaKraj />}
        <Amen />
      </div>
    </React.Fragment>
  );
}

export default observer(Zrno);
